import axios from 'axios';
import React, { useState } from 'react';
import $ from 'jquery';
import * as Yup from 'yup';
import * as APIS from '../../Config/Apis';
import { getToken } from '../../Utils/Common';
import { useComponentDidMount, withRouter } from '../../Utils/Component';
import { fetchAgents, fetchBuses, fetchCompanies, fetchCompanyBranches, fetchRouteDestinations, fetchPos, fetchRoutes } from '../../Utils/DropdownsNew';
import { useFormik } from 'formik';
import AlertDismissError from "../Layouts/AlertDismissError";
import { useNavigate } from 'react-router-dom';
import { DatePicker } from 'antd';
import moment from 'moment';

import { SearchOutlined } from '@ant-design/icons';
import { red, volcano, orange, gold, yellow, lime, green, cyan, blue, geekblue, purple, magenta, grey } from '@ant-design/colors';

import { Layout, Breadcrumb, PageHeader, Collapse, Row, Col, Button, Select, Table, Input, Space, Tag } from "antd";
import AlertError from '../Layouts/AlertError';
const { Content, Footer } = Layout;
const { Panel } = Collapse;
const { Option } = Select;

function Tickets() {
    const token = getToken();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const formik = useFormik({
        initialValues: {
            start_date: moment("00:00:00", "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
            end_date: moment("23:59:59", "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
            company_id: '',
            branch_id: '',
            agent_id: '',
            pos_id: '',
            bus_id: '',
            validated_bus_id: '',
            route_id: '',
            destination_id: '',
            ticket_date_by: 'confirm',
            ticket_status: '',
            payment_type: '',
            payment_provider: '',
            card_number: '',
            customer_phone_number: '',
        },
        validationSchema: Yup.object({
            start_date: Yup.string().required(),
            end_date: Yup.string().required(),
        }),
        onSubmit: values => {
            console.log(values);
            setError(null);
            setLoading(true);
            setTableError(null);
            if (values.company_id == '-1') {
                values.company_id = '';
            }
            if (values.branch_id == '-1') {
                values.branch_id = '';
            }
            if (values.agent_id == '-1') {
                values.agent_id = '';
            }
            if (values.pos_id == '-1') {
                values.pos_id = '';
            }
            if (values.bus_id == '-1') {
                values.bus_id = '';
            }
            if (values.route_id == '-1') {
                values.route_id = '';
            }
            if (values.destination_id == '-1') {
                values.destination_id = '';
            }
            if (values.ticket_date_by == '-1') {
                values.ticket_date_by = '';
            }
            if (values.ticket_status == '-1') {
                values.ticket_status = '';
            }
            if (values.payment_type == '-1') {
                values.payment_type = '';
            }
            if (values.payment_provider == '-1') {
                values.payment_provider = '';
            }
            let params = {
                start_date: values.start_date,
                end_date: values.end_date,
                company_id: values.company_id,
                branch_id: values.branch_id,
                agent_id: values.agent_id,
                pos_id: values.pos_id,
                bus_id: values.bus_id,
                route_id: values.route_id,
                destination_id: values.destination_id,
                ticket_date_by: values.ticket_date_by,
                ticket_status: values.ticket_status,
                payment_type: values.payment_type,
                payment_provider: values.payment_provider,
                card_number: values.card_number,
                customer_phone_number: values.customer_phone_number,
                customer_phone_number: values.customer_phone_number,
            };
            let queryStringFilter = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            console.log(queryStringFilter);
            setLoading(false);

            setFiltersQuery(queryStringFilter);
            // clearFilters();
            setTableDraw(1);
            params = { draw: 1, start: 0, length: 10 };
            let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            queryString += "&" + queryStringFilter + columnsQuery;
            getTableData(queryString);
        },
    });

    const [dropdownCompanies, setDropdownCompanies] = useState(null);
    const [dropdownCompaniesLoading, setDropdownCompaniesLoading] = useState(true);
    const [dropdownCompanyBranches, setDropdownCompanyBranches] = useState(null);
    const [dropdownCompanyBranchesLoading, setDropdownCompanyBranchesLoading] = useState(false);
    const [dropdownAgents, setDropdownAgents] = useState(null);
    const [dropdownAgentsLoading, setDropdownAgentsLoading] = useState(true);
    const [dropdownPos, setDropdownPos] = useState(null);
    const [dropdownPosLoading, setDropdownPosLoading] = useState(true);
    const [dropdownBuses, setDropdownBuses] = useState(null);
    const [dropdownBusesLoading, setDropdownBusesLoading] = useState(true);
    const [dropdownRoutes, setDropdownRoutes] = useState(null);
    const [dropdownRoutesLoading, setDropdownRoutesLoading] = useState(true);
    const [dropdownRouteDestinations, setDropdownRouteDestinations] = useState(null);
    const [dropdownRouteDestinationsLoading, setDropdownRouteDestinationsLoading] = useState(false);
    useComponentDidMount(() => {
        fetchCompanies('100%', window, token, '#select_company_id', function (data) {
            let items = data.map(d => <Option key={d.value}>{d.label}</Option>);
            setDropdownCompanies(items);
            setDropdownCompaniesLoading(false);
        });
        fetchAgents('100%', window, token, '#select_agent_id', function (data) {
            let items = data.map(d => <Option key={d.value}>{d.label}</Option>);
            setDropdownAgents(items);
            setDropdownAgentsLoading(false);
        });
        fetchPos('100%', window, token, '#select_pos_id', function (data) {
            let items = data.map(d => <Option key={d.value}>{d.label}</Option>);
            setDropdownPos(items);
            setDropdownPosLoading(false);
        });
        fetchBuses('100%', window, token, '#select_bus_id', function (data) {
            let items = data.map(d => <Option key={d.value}>{d.label}</Option>);
            setDropdownBuses(items);
            setDropdownBusesLoading(false);
        });
        fetchRoutes('100%', window, token, '#select_route_id', function (data) {
            let items = data.map(d => <Option key={d.value}>{d.label}</Option>);
            setDropdownRoutes(items);
            setDropdownRoutesLoading(false);
        });
        const params = { draw: 1, start: 0, length: 10 };
        const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        getTableData(queryString);
    });

    const [filtersQuery, setFiltersQuery] = useState('');
    const [columnsQuery, setColumnsQuery] = useState('');
    const [tableDraw, setTableDraw] = useState(1);
    const [tableData, setTableData] = useState(false);
    const [tableError, setTableError] = useState(null);
    const [tableTotalCount, setTableTotalCount] = useState(0);
    const [tableFilterCount, setTableFilterCount] = useState(0);
    const [tableFilterValues, setTableFilterValues] = useState(null);
    const clearFilters = () => {
        setTableFilterValues(null);
    };
    const searchColumnText = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    // onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    onPressEnter={() => { confirm() }}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const searchColumnDate = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                {
                    selectedKeys[0] ? <DatePicker
                        style={{ marginBottom: 8, display: 'block' }}
                        defaultValue={moment(selectedKeys[0], "YYYY-MM-DD")}
                        onChange={(moment) => {
                            try {
                                setSelectedKeys([moment.format("YYYY-MM-DD")]);
                            } catch (e) {
                                setSelectedKeys([]);
                            }
                        }}
                    /> : <DatePicker
                        style={{ marginBottom: 8, display: 'block' }}
                        onChange={(moment) => {
                            try {
                                setSelectedKeys([moment.format("YYYY-MM-DD")]);
                            } catch (e) {
                                setSelectedKeys([]);
                            }
                        }}
                    />
                }
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const searchColumnSelectChannels = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Select defaultValue={selectedKeys[0]} style={{ marginBottom: 8, display: 'block' }} onChange={value => setSelectedKeys(value ? [value] : [])}>
                    <Option value="-1">ALL</Option>
                    <Option value="0">UNDEFINED</Option>
                    <Option value="1">POS</Option>
                    <Option value="2">MOBILE</Option>
                    <Option value="3">USSD</Option>
                    <Option value="4">WEB</Option>
                    <Option value="5">WEB-AGENT</Option>
                    <Option value="6">KIOSK</Option>
                </Select>
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const searchColumnSelectPaymentTypes = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Select defaultValue={selectedKeys[0]} style={{ marginBottom: 8, display: 'block' }} onChange={value => setSelectedKeys(value ? [value] : [])}>
                    <Option value="-1">ALL</Option>
                    <Option value="1">CASH</Option>
                    <Option value="2">MOMO</Option>
                    <Option value="3">CARD</Option>
                    <Option value="4">CENTRIKA</Option>
                </Select>
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const searchColumnSelectPaymentProviders = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Select defaultValue={selectedKeys[0]} style={{ marginBottom: 8, display: 'block' }} onChange={value => setSelectedKeys(value ? [value] : [])}>
                    <Option value="-1">ALL</Option>
                    <Option value="0">NONE</Option>
                    <Option value="1">MTN</Option>
                    <Option value="2">TIGO</Option>
                    <Option value="3">AIRTEL</Option>
                </Select>
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const searchColumnSelectStatus = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Select defaultValue={selectedKeys[0]} style={{ marginBottom: 8, display: 'block' }} onChange={value => setSelectedKeys(value ? [value] : [])}>
                    <Option value="-1">ALL</Option>
                    <Option value="0">PENDING</Option>
                    <Option value="1">REQUESTED</Option>
                    <Option value="2">CONFIRMED</Option>
                    <Option value="3">CANCELLED</Option>
                    <Option value="4">VALIDATED</Option>
                    <Option value="5">RESERVED</Option>
                    <Option value="6">TRANSFERRED</Option>
                </Select>
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const tableColumns = [
        "ticket_id", // 0
        "schedule_id", // 1
        "travel_time", // 2
        "price", // 3
        "bus_plate_number", // 4
        "destination_name", // 5
        "route_name", // 6
        "company_name", // 7
        "company_branch_name", // 8
        "agent_name", // 9
        "pos_serial_number", // 10
        "customer_name", // 11
        "customer_phone_number", // 12
        "pickup_point", // 13
        "seat_no", // 14
        "printed", // 15
        "channel", // 16
        "payment_type", // 17
        "payment_provider", // 18
        "transaction_id", // 19
        "momo_transaction_id", // 20
        "momo_transaction_status", // 21
        "card_number", // 22
        "card_transaction_id", // 23
        "card_transaction_status", // 24
        "card_company_name", // 25
        "card_old_balance", // 26
        "card_new_balance", // 27
        "promotion_code", // 28
        "promotion_count", // 29
        "customer_phone_number", // 30
        "requested_at", // 31
        "reserved_at", // 32
        "unreserved_at", // 33
        "confirmed_at", // 34
        "validated_at", // 35
        "validated_bus", // 36
        "validated_by_name", // 37
        "cancelled_at", // 38
        "cancelled_by_name", // 39
        "transferred_at", // 40
        "transferred_from", // 41
        "transferred_to", // 42
        "transferred_by_name", // 43
        "ticket_status", // 44
    ]
    const tableColumnsHead = [
        { dataIndex: tableColumns[0], filteredValue: tableFilterValues && tableFilterValues[tableColumns[0]] ? tableFilterValues[tableColumns[0]] : null, ...searchColumnText(tableColumns[0]), title: "Ticket Id" },
        { dataIndex: tableColumns[1], filteredValue: tableFilterValues && tableFilterValues[tableColumns[1]] ? tableFilterValues[tableColumns[1]] : null, ...searchColumnText(tableColumns[1]), title: "Trip Id" },
        { dataIndex: tableColumns[2], filteredValue: tableFilterValues && tableFilterValues[tableColumns[2]] ? tableFilterValues[tableColumns[2]] : null, ...searchColumnDate(tableColumns[2]), title: "Travel Time" },
        { dataIndex: tableColumns[3], filteredValue: tableFilterValues && tableFilterValues[tableColumns[3]] ? tableFilterValues[tableColumns[3]] : null, ...searchColumnText(tableColumns[3]), title: "Price" },
        { dataIndex: tableColumns[4], filteredValue: tableFilterValues && tableFilterValues[tableColumns[4]] ? tableFilterValues[tableColumns[4]] : null, ...searchColumnText(tableColumns[4]), title: "Trip Bus" },
        { dataIndex: tableColumns[5], filteredValue: tableFilterValues && tableFilterValues[tableColumns[5]] ? tableFilterValues[tableColumns[5]] : null, ...searchColumnText(tableColumns[5]), title: "Destination" },
        { dataIndex: tableColumns[6], filteredValue: tableFilterValues && tableFilterValues[tableColumns[6]] ? tableFilterValues[tableColumns[6]] : null, ...searchColumnText(tableColumns[6]), title: "Route" },
        { dataIndex: tableColumns[7], filteredValue: tableFilterValues && tableFilterValues[tableColumns[7]] ? tableFilterValues[tableColumns[7]] : null, ...searchColumnText(tableColumns[7]), title: "Company" },
        { dataIndex: tableColumns[8], filteredValue: tableFilterValues && tableFilterValues[tableColumns[8]] ? tableFilterValues[tableColumns[8]] : null, ...searchColumnText(tableColumns[8]), title: "Branch" },
        { dataIndex: tableColumns[9], filteredValue: tableFilterValues && tableFilterValues[tableColumns[9]] ? tableFilterValues[tableColumns[9]] : null, ...searchColumnText(tableColumns[9]), title: "Agent" },
        { dataIndex: tableColumns[10], filteredValue: tableFilterValues && tableFilterValues[tableColumns[10]] ? tableFilterValues[tableColumns[10]] : null, ...searchColumnText(tableColumns[10]), title: "Pos" },
        { dataIndex: tableColumns[11], filteredValue: tableFilterValues && tableFilterValues[tableColumns[11]] ? tableFilterValues[tableColumns[11]] : null, ...searchColumnText(tableColumns[11]), title: "Customer Name" },
        { dataIndex: tableColumns[12], filteredValue: tableFilterValues && tableFilterValues[tableColumns[12]] ? tableFilterValues[tableColumns[12]] : null, ...searchColumnText(tableColumns[12]), title: "Customer Phone" },
        { dataIndex: tableColumns[13], filteredValue: tableFilterValues && tableFilterValues[tableColumns[13]] ? tableFilterValues[tableColumns[13]] : null, ...searchColumnText(tableColumns[13]), title: "Pickup Point" },
        { dataIndex: tableColumns[14], filteredValue: tableFilterValues && tableFilterValues[tableColumns[14]] ? tableFilterValues[tableColumns[14]] : null, ...searchColumnText(tableColumns[14]), title: "Seat No." },
        { dataIndex: tableColumns[15], filteredValue: tableFilterValues && tableFilterValues[tableColumns[15]] ? tableFilterValues[tableColumns[15]] : null, ...searchColumnText(tableColumns[15]), title: "Printed" },
        {
            dataIndex: tableColumns[16], filteredValue: tableFilterValues && tableFilterValues[tableColumns[16]] ? tableFilterValues[tableColumns[16]] : null, ...searchColumnSelectChannels(tableColumns[16]), title: "Channel",
            render: value => {
                let color = blue.primary;
                if (value === 'undefined') {
                    color = blue.primary;
                }
                if (value === 'pos') {
                    color = blue.primary;
                }
                if (value === 'mobile') {
                    color = blue.primary;
                }
                if (value === 'ussd') {
                    color = blue.primary;
                }
                if (value === 'web') {
                    color = blue.primary;
                }
                if (value === 'web-agent') {
                    color = blue.primary;
                }
                if (value === 'kiosk') {
                    color = blue.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value.toUpperCase()}
                    </Tag>
                );
            }
        },
        {
            dataIndex: tableColumns[17], filteredValue: tableFilterValues && tableFilterValues[tableColumns[17]] ? tableFilterValues[tableColumns[17]] : null, ...searchColumnSelectPaymentTypes(tableColumns[17]), title: "Payment Type",
            render: value => {
                let color = purple.primary;
                if (value === 'none') {
                    color = purple.primary;
                }
                if (value === 'cash') {
                    color = purple.primary;
                }
                if (value === 'momo') {
                    color = purple.primary;
                }
                if (value === 'card') {
                    color = purple.primary;
                }
                if (value === 'centrika') {
                    color = purple.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value.toUpperCase()}
                    </Tag>
                );
            }
        },
        {
            dataIndex: tableColumns[18], filteredValue: tableFilterValues && tableFilterValues[tableColumns[18]] ? tableFilterValues[tableColumns[18]] : null, ...searchColumnSelectPaymentProviders(tableColumns[18]), title: "Payment Provider",
            render: value => {
                let color = cyan.primary;
                if (value === 'none') {
                    color = cyan.primary;
                }
                if (value === 'mtn') {
                    color = cyan.primary;
                }
                if (value === 'tigo') {
                    color = cyan.primary;
                }
                if (value === 'airtel') {
                    color = cyan.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value.toUpperCase()}
                    </Tag>
                );
            }
        },
        { dataIndex: tableColumns[19], filteredValue: tableFilterValues && tableFilterValues[tableColumns[19]] ? tableFilterValues[tableColumns[19]] : null, ...searchColumnText(tableColumns[19]), title: "Transaction Id" },
        { dataIndex: tableColumns[20], filteredValue: tableFilterValues && tableFilterValues[tableColumns[20]] ? tableFilterValues[tableColumns[20]] : null, ...searchColumnText(tableColumns[20]), title: "Momo Transaction Id" },
        { dataIndex: tableColumns[21], filteredValue: tableFilterValues && tableFilterValues[tableColumns[21]] ? tableFilterValues[tableColumns[21]] : null, ...searchColumnText(tableColumns[21]), title: "Momo Transaction Status" },
        { dataIndex: tableColumns[22], filteredValue: tableFilterValues && tableFilterValues[tableColumns[22]] ? tableFilterValues[tableColumns[22]] : null, ...searchColumnText(tableColumns[22]), title: "Card Number" },
        { dataIndex: tableColumns[23], filteredValue: tableFilterValues && tableFilterValues[tableColumns[23]] ? tableFilterValues[tableColumns[23]] : null, ...searchColumnText(tableColumns[23]), title: "Card Transaction Id" },
        { dataIndex: tableColumns[24], filteredValue: tableFilterValues && tableFilterValues[tableColumns[24]] ? tableFilterValues[tableColumns[24]] : null, ...searchColumnText(tableColumns[24]), title: "Card Transaction Status" },
        { dataIndex: tableColumns[25], filteredValue: tableFilterValues && tableFilterValues[tableColumns[25]] ? tableFilterValues[tableColumns[25]] : null, ...searchColumnText(tableColumns[25]), title: "Card Company" },
        { dataIndex: tableColumns[26], filteredValue: tableFilterValues && tableFilterValues[tableColumns[26]] ? tableFilterValues[tableColumns[26]] : null, ...searchColumnText(tableColumns[26]), title: "Card Old Balance" },
        { dataIndex: tableColumns[27], filteredValue: tableFilterValues && tableFilterValues[tableColumns[27]] ? tableFilterValues[tableColumns[27]] : null, ...searchColumnText(tableColumns[27]), title: "Card New Balance" },
        { dataIndex: tableColumns[28], filteredValue: tableFilterValues && tableFilterValues[tableColumns[28]] ? tableFilterValues[tableColumns[28]] : null, ...searchColumnText(tableColumns[28]), title: "Promotion Code" },
        { dataIndex: tableColumns[29], filteredValue: tableFilterValues && tableFilterValues[tableColumns[29]] ? tableFilterValues[tableColumns[29]] : null, ...searchColumnText(tableColumns[29]), title: "Promotion Count" },
        { dataIndex: tableColumns[30], filteredValue: tableFilterValues && tableFilterValues[tableColumns[30]] ? tableFilterValues[tableColumns[30]] : null, ...searchColumnText(tableColumns[30]), title: "Promotion Customer Phone" },
        { dataIndex: tableColumns[31], filteredValue: tableFilterValues && tableFilterValues[tableColumns[31]] ? tableFilterValues[tableColumns[31]] : null, ...searchColumnDate(tableColumns[31]), title: "Booked At" },
        { dataIndex: tableColumns[32], filteredValue: tableFilterValues && tableFilterValues[tableColumns[32]] ? tableFilterValues[tableColumns[32]] : null, ...searchColumnDate(tableColumns[32]), title: "Reserved At" },
        { dataIndex: tableColumns[33], filteredValue: tableFilterValues && tableFilterValues[tableColumns[33]] ? tableFilterValues[tableColumns[33]] : null, ...searchColumnDate(tableColumns[33]), title: "Unreserved At" },
        { dataIndex: tableColumns[34], filteredValue: tableFilterValues && tableFilterValues[tableColumns[34]] ? tableFilterValues[tableColumns[34]] : null, ...searchColumnDate(tableColumns[34]), title: "Confirmed At" },
        { dataIndex: tableColumns[35], filteredValue: tableFilterValues && tableFilterValues[tableColumns[35]] ? tableFilterValues[tableColumns[35]] : null, ...searchColumnDate(tableColumns[35]), title: "Validated At" },
        { dataIndex: tableColumns[36], filteredValue: tableFilterValues && tableFilterValues[tableColumns[36]] ? tableFilterValues[tableColumns[36]] : null, ...searchColumnText(tableColumns[36]), title: "Validated Bus" },
        { dataIndex: tableColumns[37], filteredValue: tableFilterValues && tableFilterValues[tableColumns[37]] ? tableFilterValues[tableColumns[37]] : null, ...searchColumnText(tableColumns[37]), title: "Validated By" },
        { dataIndex: tableColumns[38], filteredValue: tableFilterValues && tableFilterValues[tableColumns[38]] ? tableFilterValues[tableColumns[38]] : null, ...searchColumnDate(tableColumns[38]), title: "Cancelled At" },
        { dataIndex: tableColumns[39], filteredValue: tableFilterValues && tableFilterValues[tableColumns[39]] ? tableFilterValues[tableColumns[39]] : null, ...searchColumnText(tableColumns[39]), title: "Cancelled By" },
        { dataIndex: tableColumns[40], filteredValue: tableFilterValues && tableFilterValues[tableColumns[40]] ? tableFilterValues[tableColumns[40]] : null, ...searchColumnDate(tableColumns[40]), title: "Transferred At" },
        { dataIndex: tableColumns[41], filteredValue: tableFilterValues && tableFilterValues[tableColumns[41]] ? tableFilterValues[tableColumns[41]] : null, ...searchColumnText(tableColumns[41]), title: "Transferred From" },
        { dataIndex: tableColumns[42], filteredValue: tableFilterValues && tableFilterValues[tableColumns[42]] ? tableFilterValues[tableColumns[42]] : null, ...searchColumnText(tableColumns[42]), title: "Transferred To" },
        { dataIndex: tableColumns[43], filteredValue: tableFilterValues && tableFilterValues[tableColumns[43]] ? tableFilterValues[tableColumns[43]] : null, ...searchColumnText(tableColumns[43]), title: "Transferred By" },
        {
            dataIndex: tableColumns[44], filteredValue: tableFilterValues && tableFilterValues[tableColumns[44]] ? tableFilterValues[tableColumns[44]] : null, ...searchColumnSelectStatus(tableColumns[44]), title: "Status",
            render: value => {
                let color = grey.primary;
                if (value === 'pending') {
                    color = red.primary;
                }
                if (value === 'requested') {
                    color = blue.primary;
                }
                if (value === 'confirmed') {
                    color = green.primary;
                }
                if (value === 'cancelled') {
                    color = grey.primary;
                }
                if (value === 'validated') {
                    color = lime.primary;
                }
                if (value === 'reserved') {
                    color = orange.primary;
                }
                if (value === 'transferred') {
                    color = purple.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value.toUpperCase()}
                    </Tag>
                );
            }
        },
    ];

    const tableHandleChange = (pagination, filters, sorter) => {
        console.log(filters);
        setTableFilterValues(filters);
        let columnsQuery = "";
        let index = 0
        tableColumns.forEach(column => {
            if (filters[column]) {
                let column_data = 'columns[' + index + '][data]=' + column;
                let column_name = 'columns[' + index + '][name]=';
                let column_orderable = 'columns[' + index + '][orderable]=false';
                let column_searchable = 'columns[' + index + '][searchable]=true';
                let column_search_value = 'columns[' + index + '][search][value]=' + filters[column][0];
                let column_search_regex = 'columns[' + index + '][search][regex]=false';
                columnsQuery += "&" + column_data;
                columnsQuery += "&" + column_name;
                columnsQuery += "&" + column_orderable;
                columnsQuery += "&" + column_searchable;
                columnsQuery += "&" + column_search_value;
                columnsQuery += "&" + column_search_regex;
            }
            index++;
        });
        setColumnsQuery(columnsQuery);
        const offset = pagination.current * pagination.pageSize - pagination.pageSize;
        const limit = pagination.pageSize;
        setTableDraw(tableDraw + 1);
        const params = { draw: tableDraw, start: offset, length: limit };
        let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        queryString += "&" + filtersQuery + columnsQuery;
        getTableData(queryString);
    };

    const getTableData = (queryString) => {
        console.log(queryString);
        setLoading(true);
        setTableError(null);
        const suffix = queryString === null ? "" : "?" + queryString;
        const config = {
            "url": APIS.FULL_TICKETS + suffix,
            "method": "GET",
            "timeout": 0,
            "headers": Object.assign(APIS.HEADERS, { 'Authorization': 'Bearer ' + token }),
        };
        axios(config)
            .then(function (response) {
                // console.log(JSON.stringify(response.data));
                console.log(JSON.stringify(response.data.data.datatable.recordsTotal));
                console.log(JSON.stringify(response.data.data.datatable.recordsFiltered));
                setLoading(false);
                setTableTotalCount(response.data.data.datatable.recordsTotal);
                setTableFilterCount(response.data.data.datatable.recordsFiltered);
                setTableData(response.data.data.datatable.data);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    };

    let exportCsv = () => {
        let query = "";
        if (filtersQuery != "") {
            query += filtersQuery;
        }
        if (columnsQuery != "") {
            if (query == "") {
                query += columnsQuery.substring(1);
            } else {
                query += columnsQuery;
            }
        }
        const suffix = query === null ? "" : "?" + query;
        var config = {
            method: 'get',
            url: APIS.EXPORT_FULL_TICKETS + suffix,
            headers: Object.assign(APIS.HEADERS),
        };
        // console.log(config);
        setLoading(true);
        setTableError(null);
        axios(config)
            .then(function (response) {
                // console.log(JSON.stringify(response.data));
                let filename = response.data.data.filename;
                let filepath = response.data.data.filepath;
                let fileUrl = APIS.APP_DOWNLOAD_FILE + "?filename=" + filename + "&filepath=" + filepath
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                $.ajax({
                    url: fileUrl,
                    type: 'get',
                    dataType: 'binary',
                    headers: Object.assign(APIS.HEADERS),
                    processData: false,
                    success: function (blob) {
                        var windowUrl = window.URL || window.webkitURL;
                        var url = windowUrl.createObjectURL(blob);
                        var anchor = document.createElement('a');
                        anchor.prop('href', url);
                        anchor.prop('download', filename);
                        anchor.get(0).click();
                        windowUrl.revokeObjectURL(url);
                    }
                });
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    }

    const exportButton = () => (
        <Button type="primary" loading={loading} onClick={exportCsv.bind(this)}>Export</Button>
    );

    // const goToDetails = (id) => {
    //     navigate('/full-tickets/'+id);
    // }

    return (
        <Layout>
            <Content className="site-layout" style={{ padding: "0 15px" }}>
                <Breadcrumb style={{ margin: "5px 0" }}>
                    <Breadcrumb.Item><a>Home</a></Breadcrumb.Item>
                    <Breadcrumb.Item>Tickets</Breadcrumb.Item>
                </Breadcrumb>
                <div className="site-layout-background" style={{ padding: 0, minHeight: 380 }}>
                    <PageHeader className="site-page-header" title="History Tickets" extra={exportButton()} />
                    <div style={{ padding: 10 }}>
                        <>
                            {tableError && <div style={{ marginBottom: "10px" }}><AlertError title="Error" message={tableError} /></div>}
                            <Collapse accordion style={{ marginBottom: "10px" }}>
                                <Panel header="Filters" key="1">
                                    <form noValidate="novalidate" action="#" onSubmit={formik.handleSubmit}>
                                        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 8]}>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Start Datetime</label>
                                                <DatePicker
                                                    name="start_date"
                                                    showTime defaultValue={moment("00:00:00", "HH:mm:ss")}
                                                    onOk={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("start_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("start_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                    onChange={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("start_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("start_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                />
                                                {formik.touched.start_date && formik.errors.start_date ? (<div className="ant-form-item-explain-error">{formik.errors.start_date}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>End Datetime</label>
                                                <DatePicker
                                                    name="start_date"
                                                    showTime defaultValue={moment("23:59:59", "HH:mm:ss")}
                                                    onOk={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("end_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("end_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                    onChange={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("end_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("end_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                />
                                                {formik.touched.end_date && formik.errors.end_date ? (<div className="ant-form-item-explain-error">{formik.errors.end_date}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Company</label><br />
                                                <Select name="company_id" style={{ width: "100%" }} allowClear showSearch loading={dropdownCompaniesLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { 
                                                        formik.setFieldValue("company_id", value, false);
                                                        fetchCompanyBranches('100%', window, token, '#select_branch_id', value, function (data) {
                                                            let items = data.map(d => <Option key={d.value}>{d.label}</Option>);
                                                            setDropdownCompanyBranches(items);
                                                            setDropdownCompanyBranchesLoading(false);
                                                        });
                                                    }}>
                                                    {dropdownCompanies}
                                                </Select>
                                                {formik.touched.company_id && formik.errors.company_id ? (<div className="ant-form-item-explain-error">{formik.errors.company_id}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Branch</label><br />
                                                <Select name="branch_id" style={{ width: "100%" }} allowClear showSearch loading={dropdownCompanyBranchesLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("branch_id", value, false); }}>
                                                    {dropdownCompanyBranches}
                                                </Select>
                                                {formik.touched.branch_id && formik.errors.branch_id ? (<div className="ant-form-item-explain-error">{formik.errors.branch_id}</div>) : null}
                                            </Col>
                                        </Row>
                                        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 8]}>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Agent</label><br />
                                                <Select name="agent_id" style={{ width: "100%" }} allowClear showSearch loading={dropdownAgentsLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("agent_id", value, false); }}>
                                                    {dropdownAgents}
                                                </Select>
                                                {formik.touched.agent_id && formik.errors.agent_id ? (<div className="ant-form-item-explain-error">{formik.errors.agent_id}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Pos</label><br />
                                                <Select name="pos_id" style={{ width: "100%" }} allowClear showSearch loading={dropdownPosLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("pos_id", value, false); }}>
                                                    {dropdownPos}
                                                </Select>
                                                {formik.touched.pos_id && formik.errors.pos_id ? (<div className="ant-form-item-explain-error">{formik.errors.pos_id}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Trip Bus</label><br />
                                                <Select name="bus_id" style={{ width: "100%" }} allowClear showSearch loading={dropdownBusesLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("bus_id", value, false); }}>
                                                    {dropdownBuses}
                                                </Select>
                                                {formik.touched.bus_id && formik.errors.bus_id ? (<div className="ant-form-item-explain-error">{formik.errors.bus_id}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Validated Bus</label><br />
                                                <Select name="validated_bus_id" style={{ width: "100%" }} allowClear showSearch loading={dropdownBusesLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("validated_bus_id", value, false); }}>
                                                    {dropdownBuses}
                                                </Select>
                                                {formik.touched.validated_bus_id && formik.errors.validated_bus_id ? (<div className="ant-form-item-explain-error">{formik.errors.validated_bus_id}</div>) : null}
                                            </Col>
                                        </Row>
                                        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 8]}>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Bus Route</label><br />
                                                <Select name="route_id" style={{ width: "100%" }} allowClear showSearch loading={dropdownRoutesLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { 
                                                        formik.setFieldValue("route_id", value, false);
                                                        fetchRouteDestinations('100%', window, token, '#select_destination_id', value, function (data) {
                                                            let items = data.map(d => <Option key={d.value}>{d.label}</Option>);
                                                            setDropdownRouteDestinations(items);
                                                            setDropdownRouteDestinationsLoading(false);
                                                        });
                                                    }}>
                                                    {dropdownRoutes}
                                                </Select>
                                                {formik.touched.route_id && formik.errors.route_id ? (<div className="ant-form-item-explain-error">{formik.errors.route_id}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Destination</label><br />
                                                <Select name="destination_id" style={{ width: "100%" }} allowClear showSearch loading={dropdownRouteDestinationsLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("destination_id", value, false); }}>
                                                    {dropdownRouteDestinations}
                                                </Select>
                                                {formik.touched.destination_id && formik.errors.destination_id ? (<div className="ant-form-item-explain-error">{formik.errors.destination_id}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Filter By Date</label><br />
                                                <Select defaultValue="confirm" name="ticket_date_by" style={{ width: "100%" }} showSearch
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("ticket_date_by", value, false); }}>
                                                    <Option value="confirm">confirmed_at</Option>
                                                    <Option value="request">requested_at</Option>
                                                </Select>
                                                {formik.touched.ticket_date_by && formik.errors.ticket_date_by ? (<div className="ant-form-item-explain-error">{formik.errors.ticket_date_by}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Ticket Status</label><br />
                                                <Select name="ticket_status" style={{ width: "100%" }} allowClear showSearch loading={dropdownBusesLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("ticket_status", value, false); }}>
                                                    <Option value="-1">All</Option>
                                                    <Option value="0">PENDING</Option>
                                                    <Option value="1">REQUESTED</Option>
                                                    <Option value="2">CONFIRMED</Option>
                                                    <Option value="3">CANCELLED</Option>
                                                    <Option value="4">VALIDATED</Option>
                                                    <Option value="5">RESERVED</Option>
                                                    <Option value="6">TRANSFERRED</Option>
                                                </Select>
                                                {formik.touched.ticket_status && formik.errors.ticket_status ? (<div className="ant-form-item-explain-error">{formik.errors.ticket_status}</div>) : null}
                                            </Col>
                                        </Row>
                                        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 8]}>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Payment Type</label><br />
                                                <Select name="payment_type" style={{ width: "100%" }} allowClear showSearch
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("payment_type", value, false); }}>
                                                        <Option value="-1">All</Option>
                                                        <Option value="1">CASH</Option>
                                                        <Option value="2">MOMO</Option>
                                                        <Option value="3">CARD</Option>
                                                        <Option value="4">CENTRIKA</Option>
                                                </Select>
                                                {formik.touched.payment_type && formik.errors.payment_type ? (<div className="ant-form-item-explain-error">{formik.errors.payment_type}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Payment Provider</label><br />
                                                <Select name="payment_provider" style={{ width: "100%" }} allowClear showSearch
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("payment_provider", value, false); }}>
                                                        <Option value="-1">All</Option>
                                                        <Option value="0">NONE</Option>
                                                        <Option value="1">MTN</Option>
                                                        <Option value="2">TIGO</Option>
                                                        <Option value="3">AIRTEL</Option>
                                                </Select>
                                                {formik.touched.payment_provider && formik.errors.payment_provider ? (<div className="ant-form-item-explain-error">{formik.errors.payment_provider}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Card Number</label><br />
                                                <Input
                                                    name="card_number" style={{ width: "100%" }}
                                                    onChange={(e) => { formik.setFieldValue("card_number", e.target.value, false); }}/>
                                                {formik.touched.card_number && formik.errors.card_number ? (<div className="ant-form-item-explain-error">{formik.errors.card_number}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Customer Phone</label><br />
                                                <Input
                                                    name="customer_phone_number" style={{ width: "100%" }}
                                                    onChange={(e) => { formik.setFieldValue("customer_phone_number", e.target.value, false); }}/>
                                                {formik.touched.customer_phone_number && formik.errors.customer_phone_number ? (<div className="ant-form-item-explain-error">{formik.errors.customer_phone_number}</div>) : null}
                                            </Col>
                                        </Row>
                                        {error && <div style={{ marginTop: "10px" }}><AlertDismissError title="Error" message={error} /></div>}
                                        <Button style={{ marginTop: "10px" }} type="primary" htmlType="submit" size="large" block loading={loading}>Submit</Button>
                                    </form>
                                </Panel>
                            </Collapse>
                            <Table
                                rowKey={tableColumns[0]}
                                columns={tableColumnsHead}
                                dataSource={tableData || []}
                                loading={loading}
                                title={null}
                                footer={null}
                                bordered={true}
                                size={'small'}
                                scroll={{ x: true }}
                                onChange={tableHandleChange}
                                pagination={{
                                    size: 'default',
                                    showSizeChanger: true,
                                    showQuickJumper: true,
                                    total: tableFilterCount,
                                    showTotal: (total, range) => {
                                        if (total == tableTotalCount) {
                                            return `${range[0]}-${range[1]} of ${total} items`;
                                        } else {
                                            return `${range[0]}-${range[1]} of ${total} items (filtered from ${tableTotalCount} total items)`;
                                        }
                                    },
                                }}
                            />
                        </>
                    </div>
                </div>
            </Content>
            <Footer style={{ textAlign: "center" }}>
                Copyright © 2022 AC GROUP | Tap&Go Ticketing v7.0.0
            </Footer>
        </Layout>
    )
}

export default withRouter(Tickets);